import TicketCreateContainer from "./TicketCreateContainer"

const TicketCreate = () => {
  return (
    <div className='page-body'>
      <TicketCreateContainer />
    </div>
  )
}

export default TicketCreate